import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {RolQueryResponse, User, UsersQueryResponse} from './_models'
import {getAuth} from '../../../../auth'
import apiClient from '../../../../../../_metronic/config/apiClient'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/usuarios`
const GET_USERS_URL = `${API_URL}/usuarios/`
const ROL_URL = `${API_URL}/rol`
const usuario = getAuth()
const config: AxiosRequestConfig = {
  headers: {
    'x-token': `${usuario?.api_token}`,
  },
}

const getUsers = (query: string): Promise<UsersQueryResponse> => {
  return apiClient
    .get(`${GET_USERS_URL}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<User | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`, config)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const createUser = (user: User): Promise<User | undefined> => {
  return axios
    .post(USER_URL, user, config)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const updateUser = (user: User): Promise<User | undefined> => {
  return axios
    .put(`${USER_URL}/actualizar/${user.id}`, user, config)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.put(`${USER_URL}/eliminar/${userId}`, ``, config).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.put(`${USER_URL}/eliminar/${id}`, ``, config))
  return axios.all(requests).then(() => {})
}

const getRoles = (): Promise<RolQueryResponse> => {
  return axios.get(`${ROL_URL}`).then((d: AxiosResponse<RolQueryResponse>) => d.data)
}

export {getUsers, deleteUser, deleteSelectedUsers, getUserById, createUser, updateUser, getRoles}
